export const globalKeyboardShortcuts = [
  {
    command: "exit_app",
    shortcut: ["Ctrl", "E"],
    usage: "Exit or quit the application",
  },
  {
    command: "minimize_app",
    shortcut: ["Ctrl", "ArrowDown"],
    usage: "Minimize the application window",
  },
  {
    command: "maximize_app",
    shortcut: ["Ctrl", "ArrowUp"],
    usage: "Maximize the application window",
  },
  {
    command: "focus_search",
    shortcut: ["Ctrl", "k"],
    usage: "Focus on current app search",
  },
];
